import { OrderExtStatus, RRStatus } from '@/types/common';

export default {
  data: [
    {
      ref: 'https://tms-live.idata.shopeemobile.com/tracker/request/710',
      pageType: 'shopee_assistant',
      data: [
        {
          pageSection: 'shopee_pay',
          data: [
            {
              targetType: 'transaction_card',
              data: [
                {
                  operation: 'impression',
                  dataField: ['location', 'chat_session_id', 'chat_dialogue_id'],
                },
                {
                  operation: 'click',
                  dataField: ['location', 'chat_session_id', 'chat_dialogue_id'],
                },
              ],
            },
            {
              targetType: 'dont_see_button',
              data: [
                {
                  operation: 'impression',
                  dataField: ['location', 'chat_session_id', 'chat_dialogue_id'],
                },
                {
                  operation: 'click',
                  dataField: ['location', 'chat_session_id', 'chat_dialogue_id'],
                },
              ],
            },
            {
              targetType: 'other_transaction',
              data: [
                {
                  operation: 'impression',
                  dataField: ['location', 'chat_session_id', 'chat_dialogue_id'],
                },
                {
                  operation: 'click',
                  dataField: ['location', 'chat_session_id', 'chat_dialogue_id'],
                },
              ],
            },
          ],
        },
        {
          pageSection: 'shopee_pay_panel',
          data: [
            {
              targetType: 'transaction_card',
              data: [
                {
                  operation: 'impression',
                  dataField: ['location', 'chat_session_id', 'chat_dialogue_id'],
                },
                {
                  operation: 'click',
                  dataField: ['location', 'chat_session_id', 'chat_dialogue_id'],
                },
              ],
            },
            {
              targetType: 'dont_see_button',
              data: [
                {
                  operation: 'impression',
                  dataField: ['chat_session_id', 'chat_dialogue_id'],
                },
                {
                  operation: 'click',
                  dataField: ['chat_session_id', 'chat_dialogue_id'],
                },
              ],
            },
          ],
        },
      ],
    },
  ],
};

// report to sg BI
export enum TRACKING_OPERATION {
  VIEW = 'view',
  CLICK = 'click',
  ACTION_SEAECH = 'action_search',
  IMPRESSION = 'impression',
  PERFORMANCE = 'performance',
  ACTION_HIPO = 'action_hipo',
  ACTION_START_TYPING = 'action_start_typing',
  TO_LIVE_AGENT = 'to_live_agent',
  REDIRECT = 'redirect',
  EXIT = 'exit',
  ACTION_FINISH_UPLOAD_SEND = 'action_finish_upload_send',
  ACTION_FINISH_LOAD_HISTORY = 'action_finish_loading',
  ACTION_START_LOAD_HISTORY = 'action_load_history',
  LOST_TRANSIFY_KEYS = 'lost_transify_keys',
  ACTION_LIVEAGENT_CONNECTED = 'action_liveagent_connected',
  ACTION_LIVEAGENT_ENTER_QUEUE = 'action_liveagent_enter_queue',
  ACTION_SCROLL = 'action_scroll',
  ACTION_REPORT_DEVICE_INFO = 'action_report_device_info',
  SKIP = 'skip',
}

export enum TRACKING_PAGE {
  MAIN_PAGE = 'shopee_assistant',
  GAME_HIPO_TRACK = 'game_hipo_track',
  CHANNEL_CHAT_PAGE = 'inhouse_cs_channel_chat_page',
  CS_CHAT_APP = 'cs_chat_app',
}

export enum TRACKING_SECTION {
  livechatEndChat = 'livechat_end_chat',
  livechatSendOrder = 'livechat_send_order',
  livechatSendImage = 'livechat_send_image',
  inboundOrderSelection = 'cs_chat_order_selection_page',
  newHotQuestionCat = 'hot_question',
  hotQuestionCat = 'hot_question',
  hotQuestion = 'hot_question',
  orderCardHotQuestion = 'order_card_hot_question',
  shortcut = 'bottom_question',
  article = '',
  articleGroup = '',
  button = '',
  order = '',
  otherOrder = '',
  orderCardOtherOrder = 'order_card_hot_question',
  panelOrder = 'order_panel',
  singleOrderCard = '',
  agent = '',
  back = '',
  shopeePay = 'shopee_pay',
  shopeePayPanel = 'shopee_pay_panel',
  shopeePayTransactionCard = 'shopee_pay',
  shopeePayOtherTransaction = 'shopee_pay',
  shopeePayDontSeeButton = 'shopee_pay',
  shopeePayPanelTransactionCard = 'shopee_pay_panel',
  shopeePayPanelDontSeeButton = 'shopee_pay_panel',
  typingSuggestion = '',
  intentPredictionSuggestion = 'suggestion_prediction',
  // rr = 'return_refund_request',
  // otherRR = 'return_refund_request',
  standardizeButton = 'standardize_button',
  chatSessionConflict = '',
  loadingHistory = '',
  reloadImage = '',
  reloadArticle = '',
  deletedArticle = '',
  scrollToBottom = '',
  newMsgPopUp = '',
  orderSelection = 'order_selection',
  noMoreMessage = '',
  noMoreMessageExceedDuration = '',
  image = '',
  file = '',
  video = '',
  plusPanelGallery = 'plus_panel',
  plusPanelCamera = 'plus_panel',
  plusPanelFile = 'plus_panel',
  videoPlayButton = '',
  videoResend = '',
  scrollDownToViewHistory = '',
  announcement = 'redirect',
  plusPanelOrders = 'plus_panel',
  myOrderListSubTab = 'my_order_list',
  myOrderListMainTab = 'my_order_list',
  myOrderListOrderDetails = 'my_order_list',
  myOrderListSelectOrder = 'my_order_list',
  myOrderListOrder = 'my_order_list',
  resendOrder = '',
  orderMessage = '',
  lostTransifyKeys = 'lost_transify_keys',
  userQueueText = 'user_queue_text',
  userQueueTextImpress = 'user_queue_text',
  userCancelQueuePopUp = 'user_cancel_queue_pop_up',
  userEmailQueuePopUp = 'user_email_us_pop_up',
  orderTipMsgButton = 'faq_alternatives_q_trigger',
  orderSelectionFAQList = 'faq_alternatives_q_list',
  orderSelectionFAQDrawerList = 'faq_alternatives_b_sheet',
  queueFilterCard = 'cs_chat_app_filter_card',
  queueFilterNoResponse = 'cs_chat_app_filter_no_response',
  richtextDetail = 'rich_text_detail',
  closeArticle = 'article_detail',
  articleDetailHyperlink = 'article_detail',
  articleDetailImgOrGif = 'article_detail',
  articleDetailRedirectionButton = 'article_detail',
  articleDetailAccordion = 'article_detail',
  newCarouselOrderCard = 'new_info_carousel_order_card',
  bigCarouselOrderCard = 'big_carousel_order_card',
  verticalListOrderCard = 'vertical_list_order_card',
  twoRowCarouselOrderCard = '2_row_carousel_order_card',
  newCarouselOtherOrder = 'new_info_carousel_order_card',
  bigCarouselOtherOrder = 'big_carousel_order_card',
  verticalListOtherOrder = 'vertical_list_order_card',
  twoRowCarouselOtherOrder = '2_row_carousel_order_card',
  oldCarousel = 'order_card',
  clarificationList = 'clarification_list',
  TFERelatedIntent = 'related_intent_faq_bubble',
  TFEOrderListScroll = 'order_card',
  TFEOrderListClosePanel = 'order_panel',
  TFEOrderListScrollPanel = 'order_panel',
  TFEOrderListTab = 'order_panel',
  TFETransactionListScroll = 'shopee_pay',
  TFETransactionListClosePanel = 'shopee_pay_panel',
  TFEOrderPanelCardButton = 'order_selection',
  repeatedSessionOrderCardBubble = 'repeated_session_order_card_bubble',
  CaseTrackerButton = 'case_tracker_recommender',
  CaseTrackerCard = 'case_tracker_recommender',
  TFEFoodBuyerOrderList = 'order_list',
  TFEFoodBuyerOrderClose = 'order_list',
  TFEFoodBuyerOrderScroll = 'order_list',
  TFEFoodBuyerOrderSelector = 'order_list',
  TFEFoodBuyerOrderListTab = 'order_list',
  tfeOrderSelector = 'node_subtext_bubble',
  orderSelector = 'subtext_bubble',
  orderList = 'order_list',
  groupOrderList = 'group_order_list',
  probingFormFormItem = 'probing_form',
  probingFormSubmit = 'probing_form',
  probingFormBackButton = 'probing_form',
  probingFormConfirm = 'confirmation_page',
  userTypeSelector = 'live_agent_user_selection',
  enquiryTypeSelector = 'live_agent_enquiry_selection',
  liveAgentOrderSelector = 'live_agent_order_selection',
  timelineCard = 'timeline_card',
  ChasingUserMessage = 'chasing_user_message',
  ChasingAutoEndMessage = 'chasing_auto_end_message',
  EndChatConfirm = 'end_chat_confirm_popover',
  liveAgentRecommender = 'live_agent_recommender',
  channelSelection = 'channel_selection',
  liveAgentChannelSelection = 'live_agent_channel_selection',
  keyAnswer = 'key_answer',
  keyAnswerFaq = 'key_answer',
  keyAnswerFaqInDetail = 'key_answer_detail',
  keyAnswerClosePopup = 'key_answer_detail',
  additionalOptionQuestion = 'additional_option',
  additionalOptionButton = 'additional_option',
  contactCourierCard = 'contact_courier_card',
  newContactCourierCardButton = 'new_contact_card',
  newContactCourierCardContactButton = 'new_contact_card',
  newContactCourierCardPopupButton = 'new_contact_card_pop_up',
  taskBotRCMDHotQuestion = 'taskbot_rcmd',
  categoryOptimisation = 'category',
  categoryOtherFrequentlyAsked = 'category',
  categorySmallerTab = 'category',
  categoryBubbleItem = 'category_bubble',
  categoryHotQuestion = 'category_question_bubble',
  changeQuestion = 'hot_question',
  viewMore = 'hot_question',
  textBoxDefaultRecommendation = 'text_box_default_recommendation',
  orderWithConfirmation = 'landing_page_small_order_card',
  faqRcmdViewMoreButton = 'faq_rcmd',
  pinnedAnnouncementClose = 'announcement',
  pinnedAnnouncementRedirect = 'announcement',
  popUpAnnouncement = 'announcement',
  faqRcmdHotQuestion = 'faq_rcmd',
  liveAgentCaseSelector = 'live_agent_connection',
  liveAgentCaseSelectorSelectionBuble = 'live_agent_connection',
  liveAgentCaseSelectorClose = 'live_agent_connection',
  liveAgentCaseSelectorSelectCase = 'live_agent_connection',
  liveAgentCaseSelectorCaseDetail = 'live_agent_connection',
  liveAgentCaseSelectorCaseDetailFromChat = 'live_agent_connection',
  liveAgentCaseSelectorCaseList = 'live_agent_connection',
  shortcutExpandButton = 'bottom_question',
  shortcutCloseButton = 'bottom_question',
  csatCardEntire = 'service_csat_in_chatbot',
  csatCardLeave = 'service_csat_in_chatbot',
  csatCardFaceButton = 'service_csat_in_chatbot',
  csatCardClickMask = 'service_csat_in_chatbot',
  // csatCardSubmitButton = 'service_csat',
  // csatCardChooseReason = 'service_csat',
  // csatCardCancelReason = 'service_csat',
  // csatCardChooseResolution = 'service_csat',
  liveAgentUserTypeSelection = 'live_agent_user_selection_bubble',
  liveAgentEnquiryTypeSelection = 'live_agent_enquiry_selection_bubble',
  liveAgentOrderInfoSelection = 'live_agent_order_selection_bubble',
  liveAgentChannelSelectionButton = 'live_agent_channel_selection_bubble',
  liveAgentConnectionEscapeButton = 'live_agent_connection_escape',
  expediteDelivery = 'expedite_delivery',
  successCard = 'success_card',
  deliveryInstruction = 'delivery_instruction',
  deliveryInstructionCard = 'delivery_instruction_card',
  webformMultiple = 'webform_multiple',
  webformSubmit = 'webform_submit',
  webformFeedback = 'webform_feedback',
}

export enum TRACKING_TARGET {
  toLiveAgent = 'to_live_agent',
  newHotQuestionCat = 'category_tab',
  hotQuestionCat = 'question_category',
  hotQuestion = 'question',
  orderCardHotQuestion = 'order_card_hot_question',
  shortcut = 'question',
  article = 'article',
  articleGroup = 'article_group',
  button = 'button',
  standardizeButton = 'button',
  order = 'order',
  otherOrder = 'other_order',
  orderCardOtherOrder = 'button',
  panelOrder = 'order',
  singleOrderCard = 'single_order_card',
  agent = 'chat_with_agent',
  back = 'back_button',
  shopeePayTransactionCard = 'transaction_card',
  shopeePayPanelTransactionCard = 'transaction_card',
  shopeePayDontSeeButton = 'dont_see_button',
  shopeePayPanelDontSeeButton = 'dont_see_button',
  shopeePayOtherTransaction = 'other_transaction',
  typingSuggestion = 'suggestion',
  intentPredictionSuggestion = 'suggestion',
  chatSessionConflict = 'chat_session_conflict',
  loadingHistory = 'loading_history',
  reloadImage = 'reload_image',
  reloadArticle = 'reload_article',
  deletedArticle = 'deleted_article',
  scrollToBottom = 'scroll_to_down',
  newMsgPopUp = 'new_message_pop_up',
  noMoreMessage = 'no_more_message',
  noMoreMessageExceedDuration = 'no_more_message_exceed_duration',
  image = 'image',
  file = 'file',
  plusPanelGallery = 'gallery',
  plusPanelCamera = 'camera',
  plusPanelFile = 'file',
  video = 'video',
  videoPlayButton = 'video_play_thumbnail',
  videoResend = 'resend_video',
  mySupportCaseButton = 'my_support_case_button',
  scrollDownToViewHistory = 'scroll_down_to_view_history',
  announcement = 'announcement',
  plusPanelOrders = 'orders',
  myOrderListSubTab = 'sub_tab',
  myOrderListMainTab = 'main_tab',
  myOrderListOrderDetails = 'order_details',
  myOrderListSelectOrder = 'select_order',
  myOrderListOrder = 'order',
  resendOrder = 'resend_order',
  orderMessage = 'order_message',
  userQueueText = 'button',
  userCancelQueuePopUp = 'button',
  userEmailQueuePopUp = 'button',
  orderTipMsgButton = 'button',
  orderSelectionFAQList = 'question',
  orderSelectionFAQDrawerList = 'question',
  closeArticle = 'close_article',
  articleDetailHyperlink = 'hyperlink',
  articleDetailImgOrGif = 'image_or_gif',
  articleDetailRedirectionButton = 'redirection_button',
  articleDetailAccordion = 'accordion_card_title',
  clarificationList = 'button',
  TFERelatedIntent = 'question',
  TFEOrderListScroll = '',
  TFEOrderListClosePanel = 'close_order_panel',
  TFEOrderListScrollPanel = '',
  TFEOrderListTab = 'tab',
  TFETransactionListScroll = '',
  TFETransactionListClosePanel = 'close_shopee_pay_panel',
  TFEOrderPanelCardButton = 'button',
  TFEFoodBuyerOrderList = '',
  TFEFoodBuyerOrderScroll = '',
  TFEFoodBuyerOrderSelector = 'order',
  TFEFoodBuyerOrderListTab = 'tab',
  TFEFoodBuyerOrderClose = 'close_list',
  repeatedSessionOrderCardBubble = 'question',
  newCarouselOrderCard = 'order',
  bigCarouselOrderCard = 'order',
  verticalListOrderCard = 'order',
  twoRowCarouselOrderCard = 'order',
  newCarouselOtherOrder = 'other_order',
  bigCarouselOtherOrder = 'other_order',
  verticalListOtherOrder = 'other_order',
  twoRowCarouselOtherOrder = 'other_order',
  // rr = 'select_request',
  // otherRR = 'other_request'
  CaseTrackerButton = 'button',
  CaseTrackerCard = 'case_card',
  orderSelector = 'button',
  tfeOrderSelector = 'button',
  orderListClosePanel = 'close_list',
  orderList = 'list',
  probingFormFormItem = 'question',
  probingFormSubmit = 'submit_button',
  probingFormBackButton = 'back_button',
  probingFormConfirm = 'button',
  userTypeSelector = 'button',
  enquiryTypeSelector = 'button',
  liveAgentOrderSelector = 'button',
  expandButton = 'expand_button',
  liveAgentRecommender = 'button',
  channelSelection = 'button',
  liveAgentChannelSelection = 'button',
  keyAnswer = 'key_answer',
  keyAnswerFaq = 'faq_suggestion',
  keyAnswerFaqInDetail = 'faq_suggestion',
  keyAnswerClosePopup = 'close_list',
  additionalOptionQuestion = 'question',
  additionalOptionButton = 'button',
  contactCourierCardButton = 'button',
  contactCourierCardCallDriverButton = 'call_driver_button',
  contactCourierCardCopyPasteButton = 'copy_paste_button',
  newContactCourierCardButton = 'button',
  newContactCourierCardContactButton = 'contact_button',
  newContactCourierCardPopupButton = 'button',
  taskBotRCMDHotQuestion = 'taskbot_rcmd_hq',
  categoryOptimisation = 'category_tab',
  categoryOtherFrequentlyAsked = 'other_frequently_asked',
  categorySmallerTab = 'smaller_category_tab',
  categoryBubbleItem = 'category',
  categoryHotQuestion = 'category_hot_question',
  changeQuestion = 'button',
  viewMore = 'button',
  textBoxDefaultRecommendation = 'recommendation',
  orderWithConfirmation = 'landing_page_small_order_card',
  orderWithConfirmationYes = 'yes_button',
  orderWithConfirmationNo = 'no_button',
  faqRcmdViewMoreButton = 'view_more_btn',
  pinnedAnnouncementClose = 'close_announcement',
  pinnedAnnouncementRedirect = 'redirect',
  popUpAnnouncement = 'pop_up_announcement',
  faqRcmdHotQuestion = 'faq_rcmd_hq',
  liveAgentCaseSelector = 'view_selection_bubble',
  liveAgentCaseSelectorSelectionBuble = 'selection_bubble',
  liveAgentCaseSelectorClose = 'close_case_list',
  liveAgentCaseSelectorSelectCase = 'select_case',
  liveAgentCaseSelectorCaseDetail = 'case_detail_from_list',
  liveAgentCaseSelectorCaseDetailFromChat = 'case_detail_from_chat',
  liveAgentCaseSelectorCaseList = 'view_case_list',
  shortcutExpandButton = 'expand_button',
  shortcutCloseButton = 'close_button',
  csatCardEntire = 'card',
  csatCardFaceButton = 'face',
  // csatCardSubmitButton = 'submit',
  // csatCardChooseReason = 'choose_reason',
  // csatCardCancelReason = 'cancel_reason',
  // csatCardChooseResolution = 'choose_resolution',
  csatCardLeave = 'leave_button',
  csatCardClickMask = 'grey_area',
  imageOrGif = 'image_or_gif',
  table = 'table',
  hyperlink = 'hyperlink',
  redirectionButton = 'redirection_button',
  accordionCardTitle = 'accordion_card_title',
  richtextDetail = 'rich_text_detail',
  liveAgentUserTypeSelection = 'button',
  liveAgentEnquiryTypeSelection = 'button',
  liveAgentOrderInfoSelection = 'button',
  liveAgentChannelSelectionButton = 'button',
  liveAgentConnectionEscapeButton = 'button',
  expediteDelivery = 'expedite_delivery',
  expediteDeliveryButton = 'expedite_delivery_button',
  successCard = 'success_card',
  deliveryInstructionField = 'delivery_instruction_field',
  deliveryInstructionCard = 'delivery_instruction_card',
  webformMultiple = 'page_click',
  webformSubmit = 'page_click',
  webformFeedback = 'page_click',
}

export enum TRACKING_TYPE {
  toLiveAgent = 'toLiveAgent',
  NEW_HOT_QUESTION_CAT = 'newHotQuestionCat',
  HOTQUESTIONCAT = 'hotQuestionCat',
  HOTQUESTION = 'hotQuestion',
  ORDER_CARD_HOT_QUESTION = 'orderCardHotQuestion',
  SHORTCUT = 'shortcut',
  ARTICLE = 'article',
  ARTICLEGROUP = 'articleGroup',
  BUTTON = 'button',
  ORDER = 'order',
  OTHERORDER = 'otherOrder',
  ORDER_CARD_OTHER_ORDER = 'orderCardOtherOrder',
  SINGLE_ORDER_CARD = 'singleOrderCard',
  // RR = 'rr',
  // OTHER_RR = 'otherRR',
  PANELORDER = 'panelOrder',
  AGENT = 'agent',
  BACK = 'back',
  SHOPEE_PAY_TRANSACTION_CARD = 'shopeePayTransactionCard',
  SHOPEE_PAY_PANEL_TRANSACTION_CARD = 'shopeePayPanelTransactionCard',
  SHOPEE_PAY_DONT_SEE_BUTTON = 'shopeePayDontSeeButton',
  SHOPEE_PAY_PANEL_DONT_SEE_BUTTON = 'shopeePayPanelDontSeeButton',
  SHOPEE_PAY_OTHER_TRANSACTION = 'shopeePayOtherTransaction',
  TYPING_SUGGESTION = 'typingSuggestion',
  INTENT_PREDICTION_SUGGESTION = 'intentPredictionSuggestion',
  STANDARDIZE_BUTTON = 'standardizeButton',
  CHAT_SESSION_CONFLICT = 'chatSessionConflict',
  LOADING_HISTORY = 'loadingHistory',
  RELOAD_IMAGE = 'reloadImage',
  RELOAD_ARTICLE = 'reloadArticle',
  DELETED_ARTICLE = 'deletedArticle',
  SCROLL_TO_BOTTOM = 'scrollToBottom',
  NEW_MSG_POP_UP = 'newMsgPopUp',
  NO_MORE_MESSAGE = 'noMoreMessage',
  NO_MORE_MESSAGE_EXCEED_DURATION = 'noMoreMessageExceedDuration',
  IMAGE = 'image',
  FILE = 'file',
  VIDEO = 'video',
  VIDEO_PLAY_BUTTON = 'videoPlayButton',
  VIDEO_RESEND = 'videoResend',
  MY_SUPPORT_CASE_BUTTON = 'mySupportCaseButton',
  SCROLL_DOWN_TO_VIEW_HISTORY = 'scrollDownToViewHistory',
  ANNOUNCEMENT = 'announcement',
  MY_ORDER_LIST_SUB_TAB = 'myOrderListSubTab',
  MY_ORDER_LIST_MAIN_TAB = 'myOrderListMainTab',
  MY_ORDER_LIST_ORDER_DETAILS = 'myOrderListOrderDetails',
  MY_ORDER_LIST_SELECT_ORDER = 'myOrderListSelectOrder',
  MY_ORDER_LIST_ORDER = 'myOrderListOrder',
  RESEND_ORDER = 'resendOrder',
  ORDER_MESSAGE = 'orderMessage',
  USER_QUEUE_TEXT = 'userQueueText',
  USER_QUEUE_TEXT_IMPRESS = 'userQueueTextImpress',
  USER_CANCEL_QUEUE_POPUP = 'userCancelQueuePopUp',
  USER_EMAIL_QUEUE_POPUP = 'userEmailQueuePopUp',
  ORDER_TIP_MSG_BUTTON = 'orderTipMsgButton',
  ORDER_SELECTION_FAQ_LIST = 'orderSelectionFAQList',
  ORDER_SELECTION_FAQ_DRAWER_LIST = 'orderSelectionFAQDrawerList',
  CLOSE_ARTICLE = 'closeArticle',
  ARTICLE_DETAIL_HYPERLINK = 'articleDetailHyperlink',
  ARTICLE_DETAIL_IMG_OR_GIF = 'articleDetailImgOrGif',
  ARTICLE_DETAIL_REDIRECTION_BUTTON = 'articleDetailRedirectionButton',
  ARTICLE_DETAIL_ACCORDION = 'articleDetailAccordion',
  OLD_CAROUSEL = 'oldCarousel',
  NEW_CAROUSEL_ORDER_CARD = 'newCarouselOrderCard',
  BIG_CAROUSEL_ORDER_CARD = 'bigCarouselOrderCard',
  VERTICAL_LIST_ORDER_CARD = 'verticalListOrderCard',
  TWO_ROW_CAROUSEL_ORDER_CARD = 'twoRowCarouselOrderCard',
  CLARIFICATION_LIST = 'clarificationList',
  TFE_RELATED_INTENT = 'TFERelatedIntent',
  TFE_ORDER_LIST_SCROLL = 'TFEOrderListScroll',
  TFE_ORDER_LIST_CLOSE_PANEL = 'TFEOrderListClosePanel',
  TFE_ORDER_LIST_SCROLL_PANEL = 'TFEOrderListScrollPanel',
  TFE_ORDER_LIST_TAB = 'TFEOrderListTab',
  TFE_ORDER_PANEL_CARD_BUTTON = 'TFEOrderPanelCardButton',
  TFE_TRANSACTION_LIST_SCROLL = 'TFETransactionListScroll',
  TFE_TRANSACTION_LIST_CLOSE_PANEL = 'TFETransactionListClosePanel',
  REPEATED_SESSION_ORDER_CARD_BUBBLE = 'repeatedSessionOrderCardBubble',
  CASE_TRACKER_BUTTON = 'CaseTrackerButton',
  CASE_TRACKER_CARD = 'CaseTrackerCard',
  NEW_CAROUSEL_OTHER_ORDER = 'newCarouselOtherOrder',
  BIG_CAROUSEL_OTHER_ORDER = 'bigCarouselOtherOrder',
  VERTICAL_LIST_OTHER_ORDER = 'verticalListOtherOrder',
  TWO_ROW_CAROUSEL_OTHER_ORDER = 'twoRowCarouselOtherOrder',
  TFE_FOOD_BUYER_ORDER_LIST = 'TFEFoodBuyerOrderList',
  TFE_FOOD_BUYER_ORDER_LIST_CLOSE = 'TFEFoodBuyerOrderClose',
  TFE_FOOD_BUYER_ORDER_LIST_SCROLL = 'TFEFoodBuyerOrderScroll',
  TFE_FOOD_BUYER_ORDER_SELECTOR = 'TFEFoodBuyerOrderSelector',
  TFE_FOOD_BUYER_ORDER_LIST_TAB = 'TFEFoodBuyerOrderListTab',
  ORDER_SELECTOR = 'orderSelector',
  TFE_ORDER_SELECTOR = 'tfeOrderSelector',
  ORDER_LIST = 'orderList',
  ORDER_LIST_CLOSEPANEL = 'orderListClosePanel',
  GROUP_ORDER_LIST = 'groupOrderList',
  PROBING_FORM_FORM_ITEM = 'probingFormFormItem',
  PROBING_FORM_SUBMIT = 'probingFormSubmit',
  PROBING_FORM_BACK_BUTTON = 'probingFormBackButton',
  PROBING_FORM_CONFIRM = 'probingFormConfirm',
  USER_TYPE_SELECTOR = 'userTypeSelector',
  ENQUIRY_TYPE_SELECTOR = 'enquiryTypeSelector',
  INBOUND_ORDER_SELECTOR = 'liveAgentOrderSelector',
  TIMELINE_CARD = 'timelineCard',
  EXPAND_BUTTON = 'expandButton',
  LIVE_AGENT_RECOMMENDER = 'liveAgentRecommender',
  CHANNEL_SELECTION = 'channelSelection',
  LIVE_AGENT_CHANNEL_SELECTION = 'liveAgentChannelSelection',
  KEY_ANSWER = 'keyAnswer',
  KEY_ANSWER_FAQ = 'keyAnswerFaq',
  KEY_ANSWER_FAQ_IN_DETAIL = 'keyAnswerFaqInDetail',
  KEY_ANSWER_CLOSE_POPUP = 'keyAnswerClosePopup',
  ADDITIONAL_OPTION_QUESTION = 'additionalOptionQuestion',
  ADDITIONAL_OPTION_BUTTON = 'additionalOptionButton',
  CONTACT_COURIER_CARD = 'contactCourierCard',
  CONTACT_COURIER_CARD_BUTTON = 'contactCourierCardButton',
  CONTACT_COURIER_CARD_CALL_DRIVER_BUTTON = 'contactCourierCardCallDriverButton',
  CONTACT_COURIER_CARD_COPY_PASTE_BUTTON = 'contactCourierCardCopyPasteButton',
  NEW_CONTACT_COURIER_CARD_BUTTON = 'newContactCourierCardButton',
  NEW_CONTACT_COURIER_CARD_CONTACT_BUTTON = 'newContactCourierCardContactButton',
  NEW_CONTACT_COURIER_CARD_POPUP_BUTTON = 'newContactCourierCardPopupButton',
  TASK_BOT_RCMD_HOT_QUESTION = 'taskBotRCMDHotQuestion',
  CATEGORY_OPTIMISATION = 'categoryOptimisation',
  CATEGORY_OTHER_FREQUENTLY_ASKED = 'categoryOtherFrequentlyAsked',
  CATEGORY_SMALLER_TAB = 'categorySmallerTab',
  CATEGORY_BUBBLE_ITEM = 'categoryBubbleItem',
  CATEGORY_HOT_QUESTION = 'categoryHotQuestion',
  CHANGE_QUESTION = 'changeQuestion',
  VIEW_MORE = 'viewMore',
  TEXT_BOX_DEFAULT_RECOMMENDATION = 'textBoxDefaultRecommendation',
  ORDER_WITH_CONFIRMATION = 'orderWithConfirmation',
  ORDER_WITH_CONFIRMATION_YES = 'orderWithConfirmationYes',
  ORDER_WITH_CONFIRMATION_NO = 'orderWithConfirmationNo',
  FAQ_RCMD_VIEW_MORE_BUTTON = 'faqRcmdViewMoreButton',
  PINNED_ANNOUNCEMENT_CLOSE = 'pinnedAnnouncementClose',
  PINNED_ANNOUNCEMENT_REDIRECT = 'pinnedAnnouncementRedirect',
  POP_UP_ANNOUNCEMENT = 'popUpAnnouncement',
  FAQ_RCMD_HOT_QUESTION = 'faqRcmdHotQuestion',
  LIVE_AGENT_CASE_SELECTOR = 'liveAgentCaseSelector',
  LIVE_AGENT_CASE_SELECTOR_CASE_LIST = 'liveAgentCaseSelectorCaseList',
  LIVE_AGENT_CASE_SELECTOR_SELECTION_BUBLE = 'liveAgentCaseSelectorSelectionBuble',
  LIVE_AGENT_CASE_SELECTOR_CLOSE = 'liveAgentCaseSelectorClose',
  LIVE_AGENT_CASE_SELECTOR_SELECT_CASE = 'liveAgentCaseSelectorSelectCase',
  LIVE_AGENT_CASE_SELECTOR_CASE_DETAIL = 'liveAgentCaseSelectorCaseDetail',
  LIVE_AGENT_CASE_SELECTOR_CASE_DETAIL_FROM_CHAT = 'liveAgentCaseSelectorCaseDetailFromChat',
  SHORTCUT_EXPAND_BUTTON = 'shortcutExpandButton',
  SHORTCUT_CLOSE_BUTTON = 'shortcutCloseButton',
  CSAT_CARD_ENTIRE = 'csatCardEntire',
  CSAT_CARD_LEAVE = 'csatCardLeave',
  CSAT_CARD_CLICK_MASK = 'csatCardClickMask',
  CSAT_CARD_FACE_BUTTON = 'csatCardFaceButton',
  // CSAT_CARD_SUBMIT_BUTTON = 'csatCardSubmitButton',
  // CSAT_CARD_CHOOSE_REASON = 'csatCardChooseReason',
  // CSAT_CARD_CANCEL_REASON = 'csatCardCancelReason',
  // CSAT_CARD_CHOOSE_RESOLUTION = 'csatCardChooseResolution',
  LIVE_AGENT_USER_TYPE_SELECTION = 'liveAgentUserTypeSelection',
  LIVE_AGENT_ENQUIRY_TYPE_SELECTION = 'liveAgentEnquiryTypeSelection',
  LIVE_AGENT_ORDER_INFO_SELECTION = 'liveAgentOrderInfoSelection',
  LIVE_AGENT_CHANNEL_SELECTION_BUTTON = 'liveAgentChannelSelectionButton',
  LIVE_AGENT_CONNECTION_ESCAPE_BUTTON = 'liveAgentConnectionEscapeButton',
  WEBFORM_MULTIPLE_BUTTON = 'webformMultiple',
  WEBFORM_SUBMIT_BUTTON = 'webformSubmit',
  WEBFORM_FEEDBACK_BUTTON = 'webformFeedback',
}

export enum BUTTON_SELECTION {
  Select = 1,
  Back = 2,
  Close = 3,
  CanNotFind = 4,
}

export const RR_STATUS_TRACKING_MAP = {
  [RRStatus.ReturnAccepted]: 'Return_Accepted',
  [RRStatus.ReturnRefundPaid]: 'Return_Refund_Paid',
};

export const ORDER_STATUS_TRACKING_MAP = {
  [OrderExtStatus.ORDER_EXT_DELETE]: 'order_delete',
  [OrderExtStatus.ORDER_EXT_UNPAID]: 'order_unpaid',
  [OrderExtStatus.ORDER_EXT_PAID]: 'order_paid',
  [OrderExtStatus.ORDER_EXT_SHIPPED]: 'order_shipped',
  [OrderExtStatus.ORDER_EXT_COMPLETED]: 'order_completed',
  [OrderExtStatus.ORDER_EXT_INVALID]: 'order_invalid',
  [OrderExtStatus.ORDER_EXT_CANCEL_COMPLETED]: 'order_cancel_completed',
  [OrderExtStatus.ORDER_EXT_CANCEL_PROCESSING]: 'order_cancel_processing',
  [OrderExtStatus.ORDER_EXT_RETURN_PROCESSING]: 'order_return_processing',
  [OrderExtStatus.ORDER_EXT_RETURN_COMPLETED]: 'order_return_completed',
  [OrderExtStatus.ORDER_EXT_ESCROW_PAID]: 'order_escrow_paid',
  [OrderExtStatus.ORDER_EXT_ESCROW_CREATED]: 'order_escrow_created',
  [OrderExtStatus.ORDER_EXT_ESCROW_PENDING]: 'order_escrow_pending',
  [OrderExtStatus.ORDER_EXT_ESCROW_VERIFIED]: 'order_escrow_verified',
  [OrderExtStatus.ORDER_EXT_ESCROW_PAYOUT]: 'order_escrow_payout',
  [OrderExtStatus.ORDER_EXT_CANCEL_PENDING]: 'order_cancel_pending',
};

// 1.按钮可点击 2.按钮置灰
export enum ChasingButtonClickableStatus {
  Active = 1,
  Disabled = 2,
}

// 1.no,end chat 2.yes,continue
export enum ChasingStartButtonId {
  EndChat = 1,
  Continue = 2,
}

// 1.chat with agent 2.send webform
export enum ChasingEndButtonId {
  ChatWithAgent = 1,
  SendWebform = 2,
}

// 1.click end chat button 2. click no, end chat button in chasing user message 3.others
export enum EndChatConfirmType {
  EndChat = 1,
  ChasingUserEnd = 2,
  Others = 3,
}

// 1.cancel end chat 2.continue end chat
export enum EndChatButtonId {
  Cancel = 1,
  Continue = 2,
}

export enum ARTICLE_DETAIL_ANSWER_TYPE {
  RICH_TEXT = 'rich text',
  ARTICLE = 'article',
}

export enum ARTICLE_DETAIL_HYPERLINK_TYPE {
  IN_APP = 'In App',
  HTTPS = 'https',
  HTTP = 'http',
  FORM_URL = 'Form Url'
}

export enum TRACKING_OP_TYPE {
  DEFAULT = 'DEFAULT',
  API_BATCH_REPORT = 'API_BATCH_REPORT',
}
